import React, { FC } from "react";
import { Timestamp } from "../../src/generated/graphql";
import { Maybe } from "@graphql-tools/utils/typings/types";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import {
  buildTimestampDate,
  buildTimestampTime,
} from "../../helpers/formatters";

interface DateRangeFormatterProps {
  start: Maybe<Timestamp> | undefined;
  // Optional: if missing not displayed
  end?: Maybe<Timestamp>;
}

export const DateRangeFormatter: FC<DateRangeFormatterProps> = ({
  end,
  start,
}) => {
  return (
    <div>
      <span style={{ color: "black", fontWeight: 540 }}>
        <span>
          <CalendarOutlined /> {buildTimestampDate(start)}
        </span>
        {!end && (
          <span style={{ marginLeft: 10 }}>
            <ClockCircleOutlined /> {buildTimestampTime(start)}
          </span>
        )}
      </span>

      {end && (
        <span style={{ color: "black", fontWeight: 540, marginLeft: 10 }}>
          -
          <span style={{ marginLeft: 10 }}>
            <CalendarOutlined /> {buildTimestampDate(end)}
          </span>
        </span>
      )}
    </div>
  );
};
